export const IMG = {
  hero: "https://images.unsplash.com/photo-1546349851-64285be8e9fa?crop=entropy&cs=srgb&fm=jpg&q=85",
  research1: "https://images.unsplash.com/photo-1653587193700-d80e4ffbbd86?crop=entropy&cs=srgb&fm=jpg&q=85",
  research2: "https://images.unsplash.com/photo-1472803828399-39d4ac53c6e5?crop=entropy&cs=srgb&fm=jpg&q=85",
  about: "https://images.unsplash.com/photo-1652616555250-57d49a2034e2?crop=entropy&cs=srgb&fm=jpg&q=85",
  data: "https://images.unsplash.com/photo-1543286386-2e659306cd6c?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const PROFILE = {
  name: "Arpita Bhattacharyya",
  role: "Research-Led Strategy Consultant",
  tagline: "Translating economic rigor & urban data into C-suite strategy.",
  summary:
    "Research-led strategy consultant with experience in economic analysis, market sizing (TDT) and data-driven urban and infrastructure planning for public- and private-sector clients — converting complex research into C-suite-ready recommendations, diagnostic frameworks and implementation roadmaps.",
  email: "arpitabhattacharyya.92@gmail.com",
  phone: "+91 91630 24395",
  phoneHref: "+919163024395",
  linkedinLabel: "Arpita B.",
  linkedinUrl: "https://www.linkedin.com",
  location: "India · Global engagements",
  stats: [
    { value: 10, suffix: "+", label: "Years in consulting" },
    { value: 500, prefix: "$", suffix: "K+", label: "Product revenue launched" },
    { value: 500, suffix: "+", label: "Research reports authored" },
    { value: 95, suffix: "%", label: "Client satisfaction" },
  ],
  marquee: [
    "Market Sizing · TDT",
    "Economic Analysis",
    "Urban & Infrastructure Planning",
    "Sustainability & Energy Transition",
    "Digital Transformation",
    "AI / Gen AI Strategy",
    "Competitive Intelligence",
    "Strategic Advisory",
  ],
  expertise: [
    {
      title: "Data-driven Urban & Infrastructure Planning",
      blurb:
        "Evidence-based frameworks for city and regional development — integrating demographic, economic and spatial datasets into masterplans, business cases and phased roadmaps.",
      image: "research1",
    },
    {
      title: "Economic Analysis & Market Sizing (TDT)",
      blurb:
        "Top-down, bottom-up and triangulated demand estimates, revenue pools and opportunity assessments for target markets.",
    },
    {
      title: "Sustainability & Energy Transition",
      blurb:
        "Research on transition economics, energy and policy that becomes investable business cases and implementation roadmaps.",
      image: "research2",
    },
    {
      title: "Digital Transformation & AI / Gen AI",
      blurb:
        "Digital readiness diagnostics, adoption strategy and innovation research — with judgement kept human.",
    },
    {
      title: "Market & Competitive Intelligence",
      blurb:
        "Five hundred reports of discipline: competitor anatomy, industry research and analyst positioning that inform boardroom decisions.",
    },
    {
      title: "Strategic & Management Consulting",
      blurb:
        "From problem statement to phased execution — strategic options, KPIs and C-suite-ready recommendations.",
    },
  ],
  timeline: [
    {
      period: "Dec 2024 — Present",
      company: "Buro Happold",
      role: "Lead — Strategic Advisory",
      points: [
        "Research-driven strategic advisory across sustainability, digital transformation and innovation.",
        "Market sizing and opportunity assessment using TDT techniques — demand estimates and revenue pools for target markets.",
        "Data-driven urban and infrastructure planning frameworks integrating demographic, economic and spatial datasets.",
        "Reusable diagnostics: infrastructure gap assessments and digital readiness scorecards.",
      ],
    },
    {
      period: "2022 — Dec 2024",
      company: "Information Services Group (ISG)",
      role: "Research Specialist",
      points: [
        "Developed and launched a consulting product that generated $500,000+ revenue within two financial years.",
        "Strategic assessments and end-to-end sourcing lifecycle management at ~95% average client satisfaction.",
        "Sales strategy for ~30 IT service providers and 20 enterprise clients, including Fortune 500s.",
        "Advised on large IT transactions, including multi-million-dollar deals.",
      ],
    },
    {
      period: "2015 — 2022",
      company: "Tata Consultancy Services",
      role: "Senior Analyst",
      points: [
        "Authored 500+ market intelligence, competitive analysis and industry research reports.",
        "GTM strategies that drove a 20% uptick in sales pipeline conversions.",
        "Advised manufacturing, automotive and aerospace & defence clients on technology adoption and market building.",
        "Engaged C-level stakeholders on brand and market positioning.",
      ],
    },
  ],
  achievements: [
    {
      title: "Regional Winner — Tata Business Leadership Awards",
      detail:
        "Developed a business model for the Tata group creating a new revenue stream in the financial and retail sectors — selected among the top 10 of 500+ entries.",
    },
    {
      title: "10+ Performance & Excellence Awards",
      detail:
        "Across TCS, ISG and Buro Happold — including an award for creating a new revenue stream with direct bottom-line impact.",
    },
    {
      title: "Direct Client Commendations",
      detail:
        "Recognitions from enterprise executives and public-sector leadership for research-led engagements.",
    },
  ],
  certifications: [
    "BCG Strategy Consulting Job Simulation — Forage",
    "Generative AI for Business — Coursera",
  ],
  education: [
    { degree: "MBA — School of Management, KIIT University", year: "2015" },
    { degree: "B.Tech — Techno India, Banipur", year: "2013" },
  ],
  offTheClock: [
    { title: "The Singer", detail: "Classically trained — performance and practice as a lifelong discipline." },
    { title: "The Reader", detail: "Business, self-development and biographies, always within reach." },
    { title: "The Journaler", detail: "Watching and journaling documentaries on business and lives." },
    { title: "The Essayist", detail: "Creative writing at the cross-section of the professional and the personal." },
  ],
};